import { Typography } from '@mui/material';
import { useAppSelector } from 'api';
import { PayerGroupTable } from './PayerGroupTable';
import { PageContainer } from 'app';

export const PayerGroupPage = () => {
  const { currentMenuItem } = useAppSelector(state => state.menuItem);

  return (
    <PageContainer>
      <Typography variant="subtitle1">{currentMenuItem?.text}</Typography>
      <PayerGroupTable />
    </PageContainer>
  );
};
